import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '本当に痛くないですか?',
      answer: '個人差はありますが、ワイヤー矯正に比べて痛みは大幅に軽減されます。新しいマウスピースに交換した直後は締め付け感がありますが、数日で慣れる方がほとんどです。段階的に少しずつ歯を動かすため、従来の矯正のような強い痛みはほとんどありません。'
    },
    {
      question: '治療期間はどのくらいですか?',
      answer: '歯並びの状態により異なりますが、平均的には1年〜2年程度です。軽度の歯並びの乱れであれば半年程度で終わることもあります。無料カウンセリングで、あなたの場合の治療期間を詳しくお伝えします。3Dシミュレーションで治療の進行も確認できるので、ゴールが明確です。'
    },
    {
      question: '費用はどのくらいかかりますか?',
      answer: '症例により異なりますが、60万円〜100万円程度です。初回カウンセリングで詳しいお見積もりをお出しします。分割払いも可能ですので、月々の負担を抑えて治療を始めることができます。初回カウンセリングは完全無料ですので、まずはお気軽にご相談ください。'
    },
    {
      question: '年齢制限はありますか?',
      answer: '基本的に年齢制限はありません。50代、60代の方でも治療可能です。歯と歯茎が健康であれば、何歳からでも始められます。実際に当院では、40代〜50代の患者様も多く治療されています。「今さら遅い」ということはありません。'
    },
    {
      question: '1日どのくらい装着する必要がありますか?',
      answer: '1日20〜22時間の装着が推奨されます。食事と歯磨きの時以外は基本的に装着していただきます。つまり、食事中と歯磨き中の合計2〜4時間程度は外していただいて問題ありません。大切な会議やイベントの時だけ一時的に外すことも可能です。'
    },
    {
      question: '本当に誰にも気づかれませんか?',
      answer: 'マウスピースは透明な医療用プラスチック製で、装着していてもほとんど目立ちません。実際に、職場の同僚や友人に気づかれずに治療を終えた方が多数いらっしゃいます。至近距離でじっくり見られない限り、気づかれることはほとんどありません。'
    },
    {
      question: '食事制限はありますか?',
      answer: '食事の時はマウスピースを外すので、食事制限は一切ありません。ワイヤー矯正のように「硬いものが食べられない」「粘着性のものがダメ」といった制限がないので、普段通りの食生活を楽しめます。これもマウスピース矯正の大きなメリットです。'
    },
    {
      question: '虫歯になりやすくなりませんか?',
      answer: 'むしろワイヤー矯正よりも虫歯になりにくいです。マウスピースは取り外して歯磨きができるため、普段通りのケアが可能です。ワイヤー矯正では装置の周りに汚れが溜まりやすく、歯磨きが難しいですが、マウスピース矯正ならその心配がありません。'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            よくある<span className="text-teal-600">ご質問</span>
          </h2>
          <p className="text-xl text-gray-600">
            患者様からよくいただくご質問にお答えします
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white border-2 border-gray-200 rounded-xl overflow-hidden hover:border-teal-300 transition-all duration-300">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <div className="flex items-start gap-4 flex-1">
                  <div className="w-8 h-8 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0 mt-1">
                    <span className="text-teal-600 font-bold text-sm">Q</span>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 flex-1 pr-4">{faq.question}</h3>
                </div>
                <div className={`w-8 h-8 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-2xl text-teal-600"></i>
                </div>
              </button>
              
              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`}>
                <div className="px-6 pb-6">
                  <div className="flex items-start gap-4 pl-12">
                    <div className="w-8 h-8 flex items-center justify-center bg-teal-500 rounded-full flex-shrink-0">
                      <span className="text-white font-bold text-sm">A</span>
                    </div>
                    <p className="text-gray-700 leading-relaxed flex-1">{faq.answer}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-br from-teal-50 to-blue-50 rounded-2xl p-8 text-center">
          <div className="w-16 h-16 flex items-center justify-center bg-teal-500 rounded-full mx-auto mb-4">
            <i className="ri-question-answer-line text-3xl text-white"></i>
          </div>
          <h3 className="text-2xl font-bold text-gray-900 mb-3">
            その他のご質問はありますか?
          </h3>
          <p className="text-gray-700 mb-6">
            無料カウンセリングで、どんな小さな疑問にもお答えします。<br />
            お気軽にご相談ください。
          </p>
          <a href="tel:0784530828" className="inline-flex items-center gap-2 text-teal-600 font-bold hover:text-teal-700 transition-colors cursor-pointer">
            <i className="ri-phone-line text-xl"></i>
            <span>078-453-0828</span>
          </a>
        </div>
      </div>
    </section>
  );
}